export default "__VITE_ASSET__C_cj7Tzv__"